import { usePureH } from "../context/PureHContext";
import { DEPARTMENTS } from "../mocks/data";
import { Card, SectionHeader } from "../components/lib";
import { Users, Bot, User, Layers } from "lucide-react";

export default function Departments() {
  const { currentWorkspace } = usePureH();
  const totalHuman = DEPARTMENTS.reduce((n, d) => n + d.headcount.human, 0);
  const totalAi    = DEPARTMENTS.reduce((n, d) => n + d.headcount.ai,    0);

  return (
    <div data-testid="pureh-departments">
      <div className="mb-6">
        <div className="text-[10px] uppercase tracking-[0.24em] text-slate-500 mb-2">Departments</div>
        <h1 className="text-3xl font-semibold text-slate-900 tracking-tight">Inside {currentWorkspace?.name}</h1>
        <div className="mt-1 text-sm text-slate-500 inline-flex items-center gap-3">
          <span className="inline-flex items-center gap-1.5">
            <Layers size={13} className="text-slate-400" /> {DEPARTMENTS.length} departments
          </span>
          <span className="text-slate-300">·</span>
          <span className="inline-flex items-center gap-1.5">
            <User size={13} className="text-slate-400" /> {totalHuman} humans
          </span>
          <span className="text-slate-300">·</span>
          <span className="inline-flex items-center gap-1.5">
            <Bot size={13} className="text-slate-400" /> {totalAi} AI teammates
          </span>
        </div>
      </div>

      <Card padded={false}>
        <div className="p-5 border-b border-slate-100">
          <SectionHeader eyebrow="Organizational" title="Department Directory" />
        </div>
        <ul className="divide-y divide-slate-100" data-testid="departments-list">
          {DEPARTMENTS.map((d) => (
            <li key={d.key} data-testid={`dept-row-${d.key}`}
              className="p-5 hover:bg-slate-50/60 transition-colors">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 rounded bg-slate-900 text-white flex items-center justify-center text-sm font-bold flex-shrink-0">
                  {d.name.charAt(0)}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-baseline gap-3 flex-wrap">
                    <div className="text-base font-semibold text-slate-900">{d.name}</div>
                    <div className="text-[11px] uppercase tracking-[0.14em] text-slate-500">
                      Lead: <span className="text-slate-700 font-medium normal-case tracking-normal">{d.lead}</span>
                    </div>
                  </div>
                  <div className="text-sm text-slate-600 mt-1">{d.focus}</div>
                </div>
                <div className="flex flex-col items-end gap-1 flex-shrink-0">
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-medium bg-slate-100 text-slate-700">
                    <User size={11} /> {d.headcount.human}
                  </span>
                  <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-[11px] font-medium" style={{ background: "var(--ph-ai-tint)", color: "var(--ph-ai)" }}>
                    <Bot size={11} /> {d.headcount.ai}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
